export default __webpack_public_path__ + "static/media/cornerchair_example.4cc2bb60.jpg";